<template lang="pug">
  .without-overflow
    BeachImage
    LinesMotorbike
    //.alig-skew
    PlayerConcurse
    WinnersConcurse
    FooterMatricula
</template>

<script>

import BeachImage from './PageConcurso2020/BeachImage'
import LinesMotorbike from './PageConcurso2020/LinesMotorbike'
import PlayerConcurse from './PageConcurso2020/PlayerConcurse'
import WinnersConcurse from './PageConcurso2020/WinnersConcurse'
import FooterMatricula from './PageConcurso2020/FooterMatricula'

export default {
   components: {
     BeachImage,
     LinesMotorbike,
     PlayerConcurse,
     WinnersConcurse,
     FooterMatricula
   }
}
</script>

<style lang="sass" scoped>
  .alig-skew
    position: absolute
    transform: skewY(0deg) translateY(-218px)
    background: #fff
    padding: 7em 0
    z-index: -1
    width: 100%
  .without-overflow
    overflow: hidden
</style>



// WEBPACK FOOTER //
// resources/js/components/BaseConcurso2020.vue